import {Component, HostBinding, OnInit} from '@angular/core';
import {TableColumnDef} from 'app/shared/tables/table-column-def';
import {FeaturesDataService} from '../services/features.data.service';
import {Router} from '@angular/router';
import {FeaturesListQuery} from '../features-model';

@Component({
    selector: 'pr-features-browser',
    templateUrl: './features-browser.component.html',
    styleUrls: ['./features-browser.component.scss']
})
export class FeaturesBrowserComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    canNavigate = true;
    navigateLinkArr: Array<string> = ['metadata', 'settings', 'features', 'details'];
    columnsData: TableColumnDef[];
    tableId: string;
    idFieldName: string;

    constructor(
        public featuresDataService: FeaturesDataService,
        private router: Router
    ) {
        const tableInfo = FeaturesListQuery.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;

        this.idFieldName = this.columnsData[0].columnDef;
    }

    ngOnInit(): void {
    }

    public create(): void {
        this.router.navigate(['metadata', 'settings', 'features', 'add']);
    }

}
